import styled from 'styled-components';

const AllocationSelector = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-column-gap: ${(props): string => props.theme.spaces.md};

  .subViewBy {
    label {
      visibility: hidden;
    }
  }
`;

export { AllocationSelector };
